export default __webpack_public_path__ + "static/media/023-call-center.71bf83b2.png";